<div class="m-popper"
     :class="{ 'm--is-open': propOpen }">
    <slot name="trigger" />
    <portal v-if="($slots.default || $slots.header || $slots.footer) && portalCreated"
            :target-el="portalTargetSelector">
        <transition name="m--is"
                    @before-enter="onBeforeEnter"
                    @enter="onEnter"
                    @after-enter="onAfterEnter"
                    @enter-cancelled="onEnterCancelled"
                    @before-leave="onAfterLeave"
                    @leave="onLeave"
                    @after-leave="onAfterLeave"
                    @leave-cancelled="onLeaveCancelled">
            <div v-show="propOpen"
                     v-if="portalMounted"
                     ref="popper"
                     class="m-popper__article"
                     :class="[
                        {
                            'm--is-default-anim': defaultAnimActive,
                            'm--is-open': defaultAnimOpen,
                            'm--has-shadow': shadow,
                            'm--has-background': background,
                            'm--is-hidden': isHidden
                        },
                        'm--is-placement-' + placement,
                        className
                    ]"
                     :aria-hidden="!propOpen || isHidden"
                     :style="{ width: width }">
                <header v-if="$slots.header"
                        class="m-popper__header"
                        :class="{
                            'm--no-padding': !padding || !paddingHeader
                        }">
                    <slot name="header" />
                </header>
                <div v-if="$slots.default"
                     class="m-popper__body"
                     :class="{
                         'm--no-padding': !padding || !paddingBody
                     }"
                     ref="body">
                    <slot />
                </div>
                <footer v-if="$slots.footer"
                        class="m-popper__footer"
                        :class="{
                            'm--no-padding': !padding || !paddingFooter
                        }">
                    <slot name="footer" />
                </footer>
            </div>
        </transition>
    </portal>
</div>
